import React from "react"
import Game from "sgame"
import {
  SCanvas,
  Point2D,
  Vector2D,
  v,
  Rect,
  Circle,
  clamp,
  RoundedRect,
  Line,
} from "solandra"
import { Update } from "sgame"

import "./styles.styl"

type Direction = "up" | "down" | "right" | "left"

type State = {
  time: number
  direction: Direction
  lastDirection: Direction | null
}

function createInitialState(): State {
  return {
    time: 0,
    direction: "up",
    lastDirection: null,
  }
}

function update(state: State, update: Update) {
  switch (update.kind) {
    case "time":
      state.time += update.dT
      // TODO handle countdown etc
      break
    case "key":
      if (update.event === "down") {
        switch (update.key) {
          case "ArrowLeft":
            if (state.lastDirection !== "left") state.direction = "left"
            break
          case "ArrowRight":
            if (state.lastDirection !== "right") state.direction = "right"
            break
          case "ArrowDown":
            if (state.lastDirection !== "down") state.direction = "down"
            break
          case "ArrowUp":
            if (state.lastDirection !== "up") state.direction = "up"
            break
        }
      }
  }
}

function directionVector(direction: Direction): Vector2D {
  switch (direction) {
    case "up":
      return [0, -1]
    case "down":
      return [0, 1]
    case "left":
      return [-1, 0]
    case "right":
      return [1, 0]
  }
}

function render(s: SCanvas, state: State) {
  const { bottom, center } = s.meta
  s.background(25, 80, 80)

  s.draw(
    new Line(
      center,
      v.add(center, v.scale(directionVector(state.direction), 0.2))
    )
  )
}

const IndexPage = () => (
  <Game<State>
    render={render}
    update={update}
    initialState={createInitialState()}
  />
)

export default IndexPage
